// ESM-Huelle fuer lib/scripts/components/CMP_CClickNumber.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CClickNumber(id)
{
    this.construct(id);

    this.name = "CClickNumber";
    this.htmlType = "span";

    this.properties = 
    {
        table:
        {
            styles:
            {
                position: "absolute"
            }
        },
        clickCell:
        {
            styles:
            {
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "#555555",
                xbackgroundColor: "#FF0000",
                opacity: "0.5"
            }
        },
        text:
        {
            caption:
            {
                styles:
                {
                    fontSize: "6vh",
                    fontFamily: "Verdana, Sans-Serif"
                }
            },
            styles:
            {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "4.0vw",
                height: "6vw",
                backgroundColor: "#FFFFFF"
            }
        },
        styles: {}
    }
    
    this.numberArray = new Array (0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
    this.currentValue = 0;
}

CClickNumber.prototype = new CComponent;

CClickNumber.prototype.prepare = function()
{
    this.text = this.addChild(CTextLabel);
    this.text.properties.caption.value = this.numberArray[this.currentValue];
    this.text.properties = combine(this.text.properties, this.properties.text);
    this.text.prepare();
    
    this.table = this.addChild(CTable);
    this.table.properties = combine(this.table.properties, this.properties.table);
    this.table.properties.styles.top = this.properties.text.styles.top;
    this.table.properties.styles.left = this.properties.text.styles.left;
    this.table.properties.styles.width = this.properties.text.styles.width;
    this.table.properties.styles.height = this.properties.text.styles.height;
    
    var tbody = this.table.addChild(CTableBody);

    var topRow = tbody.addChild(CRow);
    this.topCell = topRow.addChild(CColumn);
    this.topCell.properties = combine(this.topCell.properties, this.properties.clickCell);
    this.topCell.properties.value = "&nbsp;";
    this.topCell.properties.styles.height = "50%";
    this.topCell.properties.events.onMousedown = this.increase;
    this.topCell.properties.attributes.onMousedown_parameter_0 = this.id;
    
    var bottomRow = tbody.addChild(CRow);
    this.bottomCell = bottomRow.addChild(CColumn);
    this.bottomCell.properties = combine(this.bottomCell.properties, this.properties.clickCell);
    this.bottomCell.properties.value = "&nbsp;";
    this.bottomCell.properties.styles.height = "50%";
    this.bottomCell.properties.events.onMousedown = this.decrease;
    this.bottomCell.properties.attributes.onMousedown_parameter_0 = this.id;
    
    this.prepared = true;
}

CClickNumber.prototype.increase = function(component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    me.currentValue++;
    
    if (me.currentValue > me.numberArray.length - 1)
        me.currentValue = 0;
        
    me.doReValue(component);
}

CClickNumber.prototype.decrease = function(component, parameters)
{
    var me = POS.getComponentById (parameters[0]);

    me.currentValue--;
    
    if (me.currentValue < 0)
        me.currentValue = me.numberArray.length - 1;
        
    me.doReValue(component);
}

CClickNumber.prototype.doReValue = function(component)
{
    this.text.caption.properties.value = this.numberArray[this.currentValue];
    this.text.caption.reValue();
    
    component.properties.styles.backgroundColor = "#AABBCC";
    component.reStyle();
    
    POS.timeout.register("CClickNumberCellMouseUp", this.cellMouseUp, component, 1, 1);
}

CClickNumber.prototype.cellMouseUp = function(component)
{
    component.properties.styles.backgroundColor = null;
    component.reStyle();
}

CClickNumber.prototype.getValue = function()
{
    return this.numberArray[this.currentValue];
}

CClickNumber.prototype.setValue = function(newValue)
{
    this.currentValue = newValue;
    this.text.caption.properties.value = this.numberArray[this.currentValue];
    this.text.caption.reValue();
}
export { CClickNumber };
